module.exports = __webpack_public_path__ + "static/media/hammer-war.76003d49.svg";